import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';

class search extends Component {

  constructor(props) {
    super(props);
    this.state = {
      searchValue: ''
    }
  }
  
  onSearch = (e) => {
    e.preventDefault()
    e.target.searchInput.blur()
    if (e.target.searchInput.value.length === 0) return

    this.props.onSearch(e.target.searchInput.value)
  }

  onSearchInput = (e, searchValue) => {
    this.setState({searchValue});
  }

  clearSearch = () => {
    this.setState({searchValue: ''}, () => this.props.onSearch(''));
  }
  
  render() {
    return (
      <div className="search-container">
        <div className="search-bar" >
          <form action="search" onSubmit={this.onSearch} autoComplete="off" spellCheck="false" autoCorrect="off" >
            <div className="search-bar--field" >
              <TextField
                name="searchInput"
                value={this.state.searchValue}
                onChange={this.onSearchInput}
                hintStyle={{fontWeight: 300}}
                hintText={`Search on ${this.props.source}`}
                fullWidth={true}
              />
            </div>
            <div className="search-bar--icon" >
              <IconButton 
              onClick={this.clearSearch}>
                <FontIcon 
                className="material-icons" 
                hoverColor="#fff" 
                color="#ADADAD" >
                  {this.state.searchValue.length === 0 ? 'search' : 'close'}
                </FontIcon>
              </IconButton>
            </div>
          </form>
        </div>
        <div className="search-source">
           <IconButton
           onClick={() => {this.clearSearch(); this.props.onChangeSource('Spotify')}}>
            <FontIcon 
            className="fab fa-spotify"
            hoverColor="#fff"
            color={this.props.source==='Spotify' ? '#fff' : '#ADADAD' } />
          </IconButton>
          <IconButton
          onClick={() => {this.clearSearch(); this.props.onChangeSource('SoundCloud')}}>
            <FontIcon 
            className="fab fa-soundcloud"
            hoverColor="#fff"
            color={this.props.source==='SoundCloud' ? '#fff' : '#ADADAD' } />
          </IconButton>
        </div>
      </div>
    );
  }
}

export default search;


// WEBPACK FOOTER //
// ./src/components/SearchBar.jsx